import * as apiUtils from "@/utils/apiUtils"

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {},
  // -----------------------------------------------------------------
  getters: {},
  // -----------------------------------------------------------------
  mutations: {},
  // -----------------------------------------------------------------
  actions: {
    // Bills
    getBill: (context, tid) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/bills/" + tid
      return apiUtils.get(path)
    },
    getBills: (context, query) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/bills"
      return apiUtils.get(path, query)
    },
    getBillsByStatus: (context, status) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/bills?status=" + status
      return apiUtils.get(path)
    },
    getBillsByTimeRange: (context, { from, to }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/bills?from=" + from + "&to=" + to
      return apiUtils.get(path)
    },
    createBill: (context, { name, number, currencyCode, vendorId, issuedAt, expiredAt, poso, memo, items }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/bills"
      return apiUtils.post(path, {
        name,
        number,
        currencyCode,
        vendorId,
        issuedAt,
        expiredAt,
        poso,
        memo,
        items
      })
    },
    updateBill: (context, { id, name, number, currencyCode, vendorId, issuedAt, expiredAt, poso, memo, items }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/bills/" + id
      return apiUtils.patch(path, {
        name,
        number,
        currencyCode,
        vendorId,
        issuedAt,
        expiredAt,
        poso,
        memo,
        items
      })
    },
    deleteBill: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/bills/" + id
      return apiUtils.delete(path)
    },
    duplicateBill: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/bills/" + id + "/duplicate"
      return apiUtils.post(path)
    },
    recordBillPayment: (context, { id, paymentAccountId, amount, note, date }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/purchases/bills/" + id + "/record-payment"
      return apiUtils.post(path, {
        paymentAccountId,
        amount,
        note,
        date
      })
    }
  }
}
